export default __webpack_public_path__ + "static/media/rm-banner-tablet.5a79ce9c.png";